import { registerNotificationScope } from '@ayocore/platform/notifications/client';
import { SUPPLIER_INVOICES_REGISTER_URL } from '../constants';

export const PROCUREMENT_SUPPLIER_INVOICES_NOTIFICATION_SCOPE = 'procurement:supplier-invoices';

/** Область реестра платежей: accounting-тип общий, поэтому уточняем раздел по ссылке. */
export function registerProcurementNotificationScopes(): void {
  registerNotificationScope({
    code: PROCUREMENT_SUPPLIER_INVOICES_NOTIFICATION_SCOPE,
    match: marker => {
      if (marker.entity_type !== 'accounting::AccountingDocumentRepository') return false;
      const path = marker.entity_url?.split(/[?#]/, 1)[0];
      return (
        path === SUPPLIER_INVOICES_REGISTER_URL ||
        Boolean(path?.match(new RegExp(`^${SUPPLIER_INVOICES_REGISTER_URL}/\\d+$`)))
      );
    },
  });
}
